import { combineReducers } from "redux";
import { searchReducer } from "./searchReducer";
import { keyReducer } from "./apiKeyReducer";
import { channelReducer } from "./channelReducer";
import { suggestedVideosReducers } from "./suggestedVideosReducers";
import home from "./homeReducer";
import currentVideoReducer from "./currentVideoReducer";
import commentsReducer from "./commentsReducers";
import { SET_REGION } from "../Actions/actionTypes";

export default combineReducers({
  searchResults: searchReducer,
  apiKey: keyReducer,
  channelInfo: channelReducer,
  suggestedVideos: suggestedVideosReducers,
  comments: commentsReducer,
  currentVideo: currentVideoReducer,
  regionCode: (state = "", action) =>
    action.type === SET_REGION ? action.payload : state,
  home
});
